/**
 * Generated by orval v6.23.0 🍺
 * Do not edit manually.
 * APIs for RCI FE
 * This document describes the APIs provided by NeoAP BE for RCI FE, designed to be integrated into NeoAP FE using `iframe`.\
These APIs utilize cookie-based authentication. All API requests must include the cookie `_ap_session`.

 * OpenAPI spec version: 1
 */
import { useMutation, useQuery, useSuspenseQuery } from '@tanstack/react-query';
import type {
  MutationFunction,
  QueryFunction,
  QueryKey,
  UseMutationOptions,
  UseQueryOptions,
  UseQueryResult,
  UseSuspenseQueryOptions,
  UseSuspenseQueryResult,
} from '@tanstack/react-query';
import type { ForbiddenResponse } from '../model/forbiddenResponse';
import type { ListReconciliationSettingsResponse } from '../model/listReconciliationSettingsResponse';
import type { NotFoundResponse } from '../model/notFoundResponse';
import type { ReconciliationSetting } from '../model/reconciliationSetting';
import type { UnauthorizedResponse } from '../model/unauthorizedResponse';
import type { UnprocessableEntityResponse } from '../model/unprocessableEntityResponse';
import type { UpsertReconciliationSettingRequest } from '../model/upsertReconciliationSettingRequest';
import { useCustomClient } from '../../mutator/custom-instance';
import type { ErrorType, BodyType } from '../../mutator/custom-instance';
import { customFomDataFn } from '../../api/formData/custom-function';

type AwaitedInput<T> = PromiseLike<T> | T;

type Awaited<O> = O extends AwaitedInput<infer T> ? T : never;

// eslint-disable-next-line
type SecondParameter<T extends (...args: any) => any> = T extends (
  config: any,
  args: infer P
) => any
  ? P
  : never;

/**
 * Returns one row per ApIntegrationService whose `features` include `reconciliation`.

Services with no `ap_reconciliation_settings` row yet are returned with `is_enabled=false` (default). The FE renders one toggle per item.

 * @summary List reconciliation settings for current office
 */
export const useListReconciliationSettingsHook = () => {
  const listReconciliationSettings =
    useCustomClient<ListReconciliationSettingsResponse>();

  return (
    options?: SecondParameter<ReturnType<typeof useCustomClient>>,
    signal?: AbortSignal
  ) => {
    return listReconciliationSettings(
      { url: `/api/js/reconciliation_settings`, method: 'GET', signal },
      options
    );
  };
};

export const getListReconciliationSettingsQueryKey = () => {
  return [`/api/js/reconciliation_settings`] as const;
};

export const useListReconciliationSettingsQueryOptions = <
  TData = Awaited<
    ReturnType<ReturnType<typeof useListReconciliationSettingsHook>>
  >,
  TError = ErrorType<UnauthorizedResponse | ForbiddenResponse>
>(options?: {
  query?: Partial<
    UseQueryOptions<
      Awaited<ReturnType<ReturnType<typeof useListReconciliationSettingsHook>>>,
      TError,
      TData
    >
  >;
  request?: SecondParameter<ReturnType<typeof useCustomClient>>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getListReconciliationSettingsQueryKey();

  const listReconciliationSettings = useListReconciliationSettingsHook();

  const queryFn: QueryFunction<
    Awaited<ReturnType<ReturnType<typeof useListReconciliationSettingsHook>>>
  > = ({ signal }) => listReconciliationSettings(requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<ReturnType<typeof useListReconciliationSettingsHook>>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type ListReconciliationSettingsQueryResult = NonNullable<
  Awaited<ReturnType<ReturnType<typeof useListReconciliationSettingsHook>>>
>;
export type ListReconciliationSettingsQueryError = ErrorType<
  UnauthorizedResponse | ForbiddenResponse
>;

/**
 * @summary List reconciliation settings for current office
 */
export const useListReconciliationSettings = <
  TData = Awaited<
    ReturnType<ReturnType<typeof useListReconciliationSettingsHook>>
  >,
  TError = ErrorType<UnauthorizedResponse | ForbiddenResponse>
>(options?: {
  query?: Partial<
    UseQueryOptions<
      Awaited<ReturnType<ReturnType<typeof useListReconciliationSettingsHook>>>,
      TError,
      TData
    >
  >;
  request?: SecondParameter<ReturnType<typeof useCustomClient>>;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const queryOptions = useListReconciliationSettingsQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
};

export const useListReconciliationSettingsSuspenseQueryOptions = <
  TData = Awaited<
    ReturnType<ReturnType<typeof useListReconciliationSettingsHook>>
  >,
  TError = ErrorType<UnauthorizedResponse | ForbiddenResponse>
>(options?: {
  query?: Partial<
    UseSuspenseQueryOptions<
      Awaited<ReturnType<ReturnType<typeof useListReconciliationSettingsHook>>>,
      TError,
      TData
    >
  >;
  request?: SecondParameter<ReturnType<typeof useCustomClient>>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getListReconciliationSettingsQueryKey();

  const listReconciliationSettings = useListReconciliationSettingsHook();

  const queryFn: QueryFunction<
    Awaited<ReturnType<ReturnType<typeof useListReconciliationSettingsHook>>>
  > = ({ signal }) => listReconciliationSettings(requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseSuspenseQueryOptions<
    Awaited<ReturnType<ReturnType<typeof useListReconciliationSettingsHook>>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type ListReconciliationSettingsSuspenseQueryResult = NonNullable<
  Awaited<ReturnType<ReturnType<typeof useListReconciliationSettingsHook>>>
>;
export type ListReconciliationSettingsSuspenseQueryError = ErrorType<
  UnauthorizedResponse | ForbiddenResponse
>;

/**
 * @summary List reconciliation settings for current office
 */
export const useListReconciliationSettingsSuspense = <
  TData = Awaited<
    ReturnType<ReturnType<typeof useListReconciliationSettingsHook>>
  >,
  TError = ErrorType<UnauthorizedResponse | ForbiddenResponse>
>(options?: {
  query?: Partial<
    UseSuspenseQueryOptions<
      Awaited<ReturnType<ReturnType<typeof useListReconciliationSettingsHook>>>,
      TError,
      TData
    >
  >;
  request?: SecondParameter<ReturnType<typeof useCustomClient>>;
}): UseSuspenseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const queryOptions =
    useListReconciliationSettingsSuspenseQueryOptions(options);

  const query = useSuspenseQuery(queryOptions) as UseSuspenseQueryResult<
    TData,
    TError
  > & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey;

  return query;
};

/**
 * Idempotent upsert on `(office_id, ap_integration_service_id)`.
The integration service is identified by `ap_integration_service_id` in the path; the body only carries `is_enabled`.
Creates the row on first call, updates `is_enabled` thereafter.

 * @summary Enable or disable reconciliation for one integration service
 */
export const useUpsertReconciliationSettingHook = () => {
  const upsertReconciliationSetting = useCustomClient<ReconciliationSetting>();

  return (
    apIntegrationServiceId: string,
    upsertReconciliationSettingRequest: BodyType<UpsertReconciliationSettingRequest>,
    options?: SecondParameter<ReturnType<typeof useCustomClient>>
  ) => {
    return upsertReconciliationSetting(
      {
        url: `/api/js/reconciliation_settings/${apIntegrationServiceId}`,
        method: 'PUT',
        headers: { 'Content-Type': 'application/json' },
        data: upsertReconciliationSettingRequest,
      },
      options
    );
  };
};

export const useUpsertReconciliationSettingMutationOptions = <
  TError = ErrorType<
    | UnauthorizedResponse
    | ForbiddenResponse
    | NotFoundResponse
    | UnprocessableEntityResponse
  >,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<ReturnType<typeof useUpsertReconciliationSettingHook>>>,
    TError,
    {
      apIntegrationServiceId: string;
      data: BodyType<UpsertReconciliationSettingRequest>;
    },
    TContext
  >;
  request?: SecondParameter<ReturnType<typeof useCustomClient>>;
}): UseMutationOptions<
  Awaited<ReturnType<ReturnType<typeof useUpsertReconciliationSettingHook>>>,
  TError,
  {
    apIntegrationServiceId: string;
    data: BodyType<UpsertReconciliationSettingRequest>;
  },
  TContext
> => {
  const { mutation: mutationOptions, request: requestOptions } = options ?? {};

  const upsertReconciliationSetting = useUpsertReconciliationSettingHook();

  const mutationFn: MutationFunction<
    Awaited<ReturnType<ReturnType<typeof useUpsertReconciliationSettingHook>>>,
    {
      apIntegrationServiceId: string;
      data: BodyType<UpsertReconciliationSettingRequest>;
    }
  > = (props) => {
    const { apIntegrationServiceId, data } = props ?? {};

    return upsertReconciliationSetting(
      apIntegrationServiceId,
      data,
      requestOptions
    );
  };

  return { mutationFn, ...mutationOptions };
};

export type UpsertReconciliationSettingMutationResult = NonNullable<
  Awaited<ReturnType<ReturnType<typeof useUpsertReconciliationSettingHook>>>
>;
export type UpsertReconciliationSettingMutationBody =
  BodyType<UpsertReconciliationSettingRequest>;
export type UpsertReconciliationSettingMutationError = ErrorType<
  | UnauthorizedResponse
  | ForbiddenResponse
  | NotFoundResponse
  | UnprocessableEntityResponse
>;

/**
 * @summary Enable or disable reconciliation for one integration service
 */
export const useUpsertReconciliationSetting = <
  TError = ErrorType<
    | UnauthorizedResponse
    | ForbiddenResponse
    | NotFoundResponse
    | UnprocessableEntityResponse
  >,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<ReturnType<typeof useUpsertReconciliationSettingHook>>>,
    TError,
    {
      apIntegrationServiceId: string;
      data: BodyType<UpsertReconciliationSettingRequest>;
    },
    TContext
  >;
  request?: SecondParameter<ReturnType<typeof useCustomClient>>;
}) => {
  const mutationOptions =
    useUpsertReconciliationSettingMutationOptions(options);

  return useMutation(mutationOptions);
};
